export const announcementBar = {
  text: "We raised $20M to help AI hire more humans.",
  linkText: "Learn More",
  linkUrl: "/blog/we-raised-20m-to-help-ai-hire-more-humans"
};

export const navLinks = [
  { label: "Products", hasDropdown: true, megaMenu: true, columns: [
    { heading: "Meet Duty AI", items: [
      { label: "AI Interviews", desc: "Conduct interviews on autopilot", href: "/product/ai-interviews" },
      { label: "Coordinator", desc: "Automate scheduling and handoffs", href: "/product/coordinator" },
      { label: "Verify", desc: "Prevent fraud and cheating", href: "/product/verify" },
      { label: "Talent Match", desc: "Rediscover your ATS talent", href: "/product/talent-match" },
      { label: "Resume Screens", desc: "Move faster with intelligent resume analysis", href: "/product/resume-screens" }
    ]},
    { heading: "Channels", items: [
      { label: "Video", desc: "Scale the most valuable step in your interview", href: "/product/video" },
      { label: "Phone", desc: "Let Duty AI call thousands of candidates instantly", href: "/product/phone" },
      { label: "SMS", desc: "Engage candidates with intelligent text conversations", href: "/product/sms" },
      { label: "WhatsApp", desc: "Conduct seamless interviews with your global candidates", href: "/product/whatsapp" }
    ]},
    { heading: "Solutions", items: [
      { label: "AI Agents", desc: "Custom-built AI agents for your business", href: "/ai-agents" },
      { label: "Enterprise", desc: "Enterprise-grade AI deployment platform", href: "/enterprise" }
    ]}
  ], featured: {
    name: "Brian Cunningham",
    title: "Managing Director",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6974a6a6c85a6cc3b9ec03c4_quote-img-bew.avif",
    logo: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c03d804dd7fb2f2317df9e_image%20350.avif",
    caseStudyLabel: "Case study",
    caseStudyTitle: "How Allen Recruitment Leverages Their AI Recruiter",
    caseStudyHref: "/customer-stories/how-allen-recruitment-leverages-their-ai-recruiter"
  }},
  { label: "Jobs", href: "/jobs" },
  { label: "Customers", href: "/customers" },
  { label: "Resources", hasDropdown: true, megaMenu: false, items: [
    { label: "Customer Stories", desc: "See how teams use Duty AI", href: "/customers" },
    { label: "Candidate Love", desc: "Why candidates rate Duty AI 5 stars", href: "/candidates-info" },
    { label: "Get in Touch", desc: "Contact our team", href: "/get-in-touch" },
    { label: "Candidate FAQ", desc: "Common questions answered", href: "/candidate-faq" }
  ]}
];

export const heroData = {
  subtitle: "Your AI Recruiter to",
  headingLine1: "Interview everyone.",
  headingLine2: "Hire the best.",
  description: "Elevate your recruiters\u2019 impact where it matters most, the human connection.",
  ctaText: "Request a demo",
  heroImage: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/69790211a44a5377e1739224_Homepage%20hero%20-%20v3.avif",
  heroVideo: "https://media.apriora.ai/storage/v1/object/public/alex.com/Hero_compressed_10_01.mp4",
  heroVideoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Hero_mobile_compressed_10_01.mp4",
  timeline: [
    { date: "June 17", text: "Job posted" },
    { date: "June 18", text: "Interviews completed" },
    { date: "June 19", text: "Offer accepted" }
  ]
};

export const logoCarousel = {
  title: "Our AI recruiter is driving results across industries globally",
  logos: [
    { name: "Robertson", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68b036641b78bcd793b06afe_Robertson.svg" },
    { name: "Horizontal", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68b036646de7c44f0d5e0329_Horizontal.svg" },
    { name: "Akraya", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68b036641b78bcd793b06ab9_Akraya.svg" },
    { name: "Onward", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68b036645d4a560930ccaf1c_Onward.svg" },
    { name: "Tier4Group", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68b036643ab7ba8216f6bae2_Tier.svg" },
    { name: "BenchmarkIT", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68b03664e90ea5156b262454_bench.svg" },
    { name: "Panther", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c989d7e5c1fcf0bc745aa6_image%201646556167.png" },
    { name: "Guardian", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c989d7b6ad60c5b86c4657_image%201646556168.png" },
    { name: "Allen", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c989d7bab8f990250ceb76_image%201646556170.png" },
    { name: "LRS", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c989d60556608cb458a4c6_lrs-corporate-logo%201.png" },
    { name: "Secunetics", url: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c989d74375836a278cd909_image%201646556171.png" }
  ]
};

export const featureDescription = "Empower your team to hire at their best, at any scale. Duty AI automates recruiting busywork, giving your recruiters the freedom to build the right candidate relationships, partner with hiring managers, and win top talent for your team.";

export const featureCards = [
  {
    label: "AI Interviews",
    title: "Natural, intelligent conversations",
    description: "Duty AI conducts personalized interviews with each candidate, acting as your always-on first round interviewer.",
    linkText: "Explore AI Interviews",
    linkUrl: "/product/ai-interviews",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6975f2ee49b820f3ac3d5f88_Natural%2C%20intelligent%20conversations.svg",
    video: "https://media.apriora.ai/storage/v1/object/public/alex.com/Interviews_compressed_10_01.mp4",
    videoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Interviews_Mobile%20Lottie_HQ.mp4"
  },
  {
    label: "Channels",
    title: "Meet candidates where they are",
    description: "Whether it\u2019s a phone call on their commute, a video interview after dinner, or a quick text, Duty AI adapts the candidate experience.",
    linkText: "Explore Channels",
    linkUrl: "/product/video",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6975f2ee3f6f252554b582ca_Meet%20candidates%20where%20they%20are.svg",
    video: "https://media.apriora.ai/storage/v1/object/public/alex.com/Channels_compressed_10_01.mp4",
    videoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Channels_mobile_compressed_10_01.mp4"
  },
  {
    label: "Verify",
    title: "Hire with confidence",
    description: "Duty AI validates identity and detects fraud with explainable signals, ensuring the person you interview is the person you hire.",
    linkText: "Explore Verify",
    linkUrl: "/product/verify",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6975f2eea0c8d1aae3e61941_447b6833c66a406f2728bccc2b0bf569_Hire%20with%20confidence.avif",
    video: "https://media.apriora.ai/storage/v1/object/public/alex.com/Verify_compressed_10_01.mp4",
    videoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Verify_mobile_compressed_10_01.mp4"
  },
  {
    label: "Coordinator",
    title: "Invest in the best",
    description: "Duty AI books qualified candidates directly on your team\u2019s calendars, handling coordination with qualified candidates automatically.",
    linkText: "Explore Coordinator",
    linkUrl: "/product/coordinator",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6975f2ee912f78e431f58b62_Invest%20in%20the%20best.avif",
    video: "https://media.apriora.ai/storage/v1/object/public/alex.com/Coordinator_compressed_10_01.mp4",
    videoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Coordinator_mobile_compressed_10_01.mp4"
  },
  {
    label: "Resume Screens",
    title: "Review resumes instantly",
    description: "Duty AI evaluates every candidate resume against your specific job criteria, immediately surfacing the best matches for interviews.",
    linkText: "Explore Resume Screens",
    linkUrl: "/product/resume-screens",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6975f2ef97fc1f723ea5d638_573bc544f217c323e463e75def570b32_Review%20resumes%20instantly.avif",
    video: "https://media.apriora.ai/storage/v1/object/public/alex.com/Resume_compressed_10_01.mp4",
    videoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Resume_mobile_compressed_10_01.mp4"
  },
  {
    label: "Talent Match",
    title: "Unlock your ATS",
    description: "Duty AI rediscovers top talent already in your ATS for every new role and automatically reaches out to turn cold profiles into active candidates.",
    linkText: "Explore Talent Match",
    linkUrl: "/product/talent-match",
    image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6975f2ef24065e5a9a35e69c_39a9efb22b8e56098cd1547943e11977_Unlock%20your%20ATS.avif",
    video: "https://media.apriora.ai/storage/v1/object/public/alex.com/Talent_compressed_10_01.mp4",
    videoMobile: "https://media.apriora.ai/storage/v1/object/public/alex.com/Talent_mobile_compressed_10_01.mp4"
  }
];

export const statsData = {
  title: "Measurable Impact",
  stats: [
    { label: "Candidates interviewed", value: "1", suffix: "Million+" },
    { label: "Candidates who prefer Duty AI", value: "96", suffix: "%" },
    { label: "Faster time-to-hire", value: "2", suffix: "x" },
    { label: "Officially supported ATS integrations", value: "33", suffix: "+" },
    { label: "Languages supported", value: "26", suffix: "+" }
  ]
};

export const accelerateData = {
  label: "Accelerate Hiring",
  subtitle: "Outreach, engagement, screening, scoring, interviews, and follow-up",
  tabs: [
    {
      title: "Hire Faster",
      description: "Duty AI engages candidates 24/7\u2014screening resumes and conducting interviews the moment they apply\u2014so you never lose a great hire to a slower process.",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6979081a14092d7155ab1c25_Hire%20Faster%20v-2.avif"
    },
    {
      title: "Engage instantly",
      description: "Candidates appreciate speed. Duty AI interacts with applicants immediately 24/7, reducing wait times and maintaining high engagement throughout the screening process.",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6979081b483512c21b5ee8c2_Engage%20instantly%20-v2.avif"
    },
    {
      title: "Evaluate Fairly",
      description: "By using standardized questions and objective rubrics, Duty AI removes \u201cgut feeling\u201d from the process and ensures fair, defensible hiring decisions based on data.",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6979081b7767ebd36e3ccdc8_Evaluate%20Fairly%20-v2.avif"
    }
  ]
};

export const testimonialsData = [
  {
    quote: "Traditionally in recruitment, there is a limit on the number of candidates that a recruiter can talk to in a day. Duty AI is a game changer, with every interested candidate being considered for the role.",
    name: "Brian Cunningham",
    title: "Managing Director, Allen Recruitment",
    avatar: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6974a6a6c85a6cc3b9ec03c4_quote-img-bew.avif",
    companyLogo: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c03d804dd7fb2f2317df9e_image%20350.avif"
  },
  {
    quote: "Duty AI even identified two amazing candidates that our professors did not initially shortlist because their CVs were not well aligned with the advertisement. We ended up moving forward with both.",
    name: "Samer Adeeb",
    title: "Engineering Chair, University of Alberta",
    avatar: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6984b41964a36725d38c8b9a_Samer%20Adeeb.avif",
    companyLogo: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/6984b419091d8096a8a6bd8c_Samer%20Adeeb%20sign.avif"
  },
  {
    quote: "Duty AI functions like a supercharged recruiting associate: it asks smart questions, surfaces key insights, and dramatically speeds up our screening process. Our recruiters focus on deeper conversations and higher-value work.",
    name: "Patrick Coggins",
    title: "CEO, CFO\u2019s Domain",
    avatar: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/699cfdebc2743d8811c464dc_quote-image-patrick.png",
    companyLogo: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/699cfe130cfd802c7004e0bc_Patrick%20Coggins%20signature.png"
  }
];

export const candidatesData = {
  title: "Candidates Love Duty AI",
  subtitle: "Hear directly from actual candidates why 96% of them give Duty AI a 5-star review",
  testimonials: [
    {
      quote: "The way that she was speaking to me and the work that was put in to that was respectful. It made me feel encouraged.",
      name: "Robyn F.",
      title: "Creative Production Lead",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd102aba9364ab4f6d20_testimonails_static_03.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/robyn_forest.mp4"
    },
    {
      quote: "Traditionally, you get to talk to a recruiter first, and they\u2019re not experts on the subject matter.",
      name: "Ace Y.",
      title: "Senior Program Manager",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd10273d5596c9e1bf68_testimonails_static_02.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/ace_yamaguchi.mp4"
    },
    {
      quote: "One thing for sure that stood out: I really liked how it transcribed. It\u2019s able to understand everything.",
      name: "Neil S.",
      title: "Business Analyst",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd10b29fd8d5f1799f49_testimonails_static_08.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/neil_shah.mp4"
    },
    {
      quote: "Duty AI definitely would be a benefit to companies. It made me as a candidate more at ease.",
      name: "Raymond T.",
      title: "Technical Project Manager",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd10c0311dcaa9103287_testimonails_static_04.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/raymond_trumpover.mp4"
    },
    {
      quote: "I really liked being able to read what the questions are, especially when I\u2019m nervous. I loved that.",
      name: "Jillian L.",
      title: "Sales Manager",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd1076e920271a2c7e52_testimonails_static_07.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/jillian_long.mp4"
    },
    {
      quote: "There\u2019s more capability in Duty AI than most recruiters or headhunters. She\u2019s able to carry out more of a conversation based on specific things that I\u2019m mentioning. That was really cool.",
      name: "Chris G.",
      title: "Senior Fintech PM",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd10984d9f1aec3e5905_testimonails_static_01.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/chris_g.mp4"
    },
    {
      quote: "It was able to pick out the key points of what I was really trying to say. I think a recruiter would\u2019ve disqualified me at that point. But, Duty AI made me feel good because Duty AI got to the heart of what I was saying.",
      name: "Elizabeth L.",
      title: "UX Researcher",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd10fd9ab7e64be00d22_testimonails_static_05.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/elizabeth_le.mp4"
    },
    {
      quote: "Duty AI comfortably understood whatever I was saying in my Indian accent, and I\u2019m also able to understand Duty AI. I think for all of the candidates who are coming from India, if Duty AI is interviewing them, it\u2019ll be very comfortable for them.",
      name: "Ritik K.",
      title: "AML Analyst",
      image: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/68c3cd107bc6ef4c1e1fa15b_testimonails_static_06.avif",
      video: "https://lp-frames-f8dmb0anf4bwgcak.z03.azurefd.net/videos/ritik.mp4"
    }
  ]
};

export const footerData = {
  logo: "https://cdn.prod.website-files.com/68aeb8386df2a4eb63bab7e3/69750bc464ed715437966e4c_Alex%20logo%20lockup.svg",
  columns: [
    {
      title: "Products",
      links: [
        { label: "AI Interviews", href: "/product/ai-interviews" },
        { label: "Coordinator", href: "/product/coordinator" },
        { label: "Verify", href: "/product/verify" },
        { label: "Talent Match", href: "/product/talent-match" },
        { label: "Resume Screens", href: "/product/resume-screens" }
      ]
    },
    {
      title: "Channels",
      links: [
        { label: "Video", href: "/product/video" },
        { label: "Phone", href: "/product/phone" },
        { label: "SMS", href: "/product/sms" },
        { label: "WhatsApp", href: "/product/whatsapp" }
      ]
    },
    {
      title: "Resources",
      links: [
        { label: "Customer Stories", href: "/customers" },
        { label: "Candidate Love", href: "/candidates-info" },
        { label: "Get in Touch", href: "/get-in-touch" },
        { label: "Candidate FAQ", href: "/candidate-faq" }
      ]
    },
    {
      title: "Company",
      links: [
        { label: "Newsroom", href: "/newsroom" },
        { label: "For Employer", href: "/for-employer" },
        { label: "Ethical AI", href: "/ethical-ai" },
        { label: "Terms of Service", href: "/terms-of-service" },
        { label: "Privacy Policy", href: "/privacy-policy" }
      ]
    }
  ],
  copyright: "Copyright \u00a9 2026 Duty AI Inc.\nAll rights reserved."
};
